/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect,useState,useContext } from "react"
import TopHeader from "../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import { useParams,useLocation,useNavigate,useSearchParams } from "react-router-dom"
import {useDispatch, useSelector} from 'react-redux'
import { useGetUserQuery } from "../../features/apiSlice"
import CustomOverLay from "../../components/CustomOverLay"
import GlobalContext from "../../components/Context/GloablContext"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import formatMobileNumber from "../../CommonMethods/FormatMobileNumber"
import { convertEpochToDateFormat } from "../../CommonMethods/DateConversion"
import OrganizationListTable from "./OrgListTable"
import { handleEditMessageSent } from "../../redux/systemConfigSlice"
import ImportHistoryTable from "./ImportHistoryTable/ImportHistory"
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import OtpPreferenceList from "../../components/OtpPreferenceList/OtpPreferenceList"
import { useAdminOrCorporateSearch } from "../../components/Context/adminCorporateSearch"

 function ViewAdminCorporateUser({isOrganization,corp_id}){
    const navigate=useNavigate()
    const [searchParams,setSearchParams] =useSearchParams()
    const {isSideBar,sendMessageToStartEditing,editSocket,setToastErrorMessage,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const { resetAdvancedAdminCorSearch } = useAdminOrCorporateSearch();

    const viewId=useSelector(state=>state?.systemConfigData?.viewToUser)
    const location=useLocation();
    const auth=useSelector(state=>state?.auth)
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
    const dispatch = useDispatch()
    const [adminCorporateInfo,setAdminCorporateInfo]=useState("");
    const [loading,setLoading]=useState(true)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const {id}=useParams()
    const {data,isFetching,status}=useGetUserQuery(isOrganization===undefined?id:corp_id, {refetchOnMountOrArgChange: true})
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    useEffect(()=>{
      if(data!==undefined){
        setAdminCorporateInfo(data)
      }
    },[data])

    const handleGobackFn = () =>{
        let params = Object.fromEntries(searchParams);
        params['view']!==null && delete params['view']
        setSearchParams({ ...params})
    }
    
    
    const handleEditButtonClick = () =>{
        if(!messageSent){
            sendMessageToStartEditing(adminCorporateInfo?.user_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-admin-corporate/add-admin-corporate/${id}`,{state:[location.state,true,id]})
                    setIsAdvancedSearchOpen(false)
                    resetAdvancedAdminCorSearch()
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this user`)
                    }
                   
                }
            }    
        }
    }   


    useEffect(() => {
        if (userType === 'corporate-user') {
            if (adminCorporateInfo.user_type!=="admin-user") {
                setQueryParamsadmin('type=corporate-view-corporate-users');
            } else {
                setQueryParamsadmin('type=corporate-view-admin-users');
            }
        } else {
            if (adminCorporateInfo.user_type!=="admin-user") {
                setQueryParamsadmin('type=admin-view-corporate-user');
            } else {
                setQueryParamsadmin('type=admin-view-admin-user');
            }
        }
    }, [userType,adminCorporateInfo.user_type]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    //const date=dateformat?.includes('AM/PM')?moment(data?.created_at+'Z')?.utcOffset('+05:30')?.format(`${dateformat?.split(',')[0]} hh:mm:ss A`):moment(data?.data?.created_at).format(dateformat)
    const date=convertEpochToDateFormat(data?.created_at,dateformat)
    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={isOrganization===undefined?"Manage Admin/Corporate Users":'Manage Organizations'}/>
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching&&status!=="fulfilled"?<CustomOverLay Active text={isOrganization===undefined?"Loading Admin/Corporate Details...":'Loading Corporate Details'} classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className="flex justify-between items-center">
                                    <div className='flex items-center mb-5'>
                                        {isOrganization===undefined?<>
                                            <Link to="/manage-admin-corporate" state={Array.isArray(location.state)?'':location.state}>
                                                <h1 className="text-sm font-normal text-[#52555D]">List of Admin/Corporate Users</h1>
                                            </Link>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <h1 className="text-sm font-normal text-[#008586]">View Admin/Corporate User</h1>
                                        </>:<>
                                            <Link to="/manage-organizations">
                                                <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                                            </Link>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        
                                            {viewId!==""&&<>
                                                <Link to={`/manage-organizations/${viewId}`}>
                                                    <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                                </Link>
                                                <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            </>} 
                                            <button onClick={handleGobackFn}>
                                                <h1 className="text-sm font-normal text-[#52555D]">List of Corporate Users</h1>
                                            </button>
                                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <h1 className="text-sm font-normal text-[#008586]">View Corporate User</h1>
                                        </>}
                                    </div> 
                                    {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
                 

                                </div>
                                
                                
                                <div className={`flex items-center mt-3 ${userType==='corporate-user'?'justify-start':'justify-between'}`}>
                                    {isOrganization===undefined?<Link to={`/manage-admin-corporate/`} state={Array.isArray(location.state)?'':location.state} className='flex items-center min-w-max'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </Link>:<button onClick={handleGobackFn} className='flex items-center min-w-max z-10'> 
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </button>}
                                    <h1 className={`${userType==='corporate-user'?'w-full':'mx-auto'} ${isOrganization!==undefined?'pr-[207px]':''} text-xl font-normal text-[#000000] text-center ${userType==='corporate-user'?'mr-[248px]':''}`}>
                                        {adminCorporateInfo.user_type==="admin-user" ? 'View Admin User': 'View Corporate User'}
                                    </h1>
                                    {isOrganization===undefined?<div className={`flex items-center `}>
                                        <button type="button" 
                                            onClick={()=>{navigate('/manage-admin-corporate/activity_history',{state:[adminCorporateInfo.user_name,true,id]}),setIsAdvancedSearchOpen(false),resetAdvancedAdminCorSearch()}}
                                            className={`py-2.5 px-4  mr-4 flex items-center text-lg font-normal text-[#fff] 
                                            rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E]
                                                focus:bg-[#863B50] disabled:bg-[#777C88]  ${userType==='corporate-user'?'hidden':''}`}>
                                            View Activity Log
                                        </button>
                                        <button onClick={handleEditButtonClick} id="edit" type='button' className={`${(userType==='admin-user'&&adminCorporateInfo?.user_type==='admin-user'||userType==='corporate-user')?'hidden':'min-w-max px-4 py-2.5 border border-[#972E4C] h-fit rounded-[16px] flex items-center'}`}>
                                            <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                            <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                        </button>
                                    </div>:''}
                                </div>
                                <div className="pt-10 pb-2 border-b border-[#C5C9DA] w-full flex justify-between items-center">
                                    <div className="flex items-center">
                                        <p className="text-xl font-semibold text-[#000000]">{adminCorporateInfo?.first_name} {adminCorporateInfo?.last_name}</p>
                                        <p className="text-sm font-normal text-[#000000] px-2">{adminCorporateInfo?.user_id}</p>
                                        {adminCorporateInfo?.status=='inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : 
                                        <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                        }
                                    </div>
                                    <div className="flex items-center">
                                        <img src="/images/admin-coporate-view.svg" alt="icon" />
                                        <p className="ml-2.5 text-lg font-semibold text-[#972E4C]">
                                            {adminCorporateInfo?.user_type==="admin-user"  ? 'Admin': 'Corporate'}
                                        </p>
                                    </div>
                                </div>
                                <div className="h-customh6 overflow-auto scrollBar-hidden">
                                    <div className="mt-[22px] bg-[#E7EAF4] rounded-lg px-5 pt-[30px] pb-[22px]">
                                        <div className="flex -mx-1 flex-wrap">
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Username</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {adminCorporateInfo?.user_name}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {adminCorporateInfo?.email_address!==""?adminCorporateInfo?.email_address:'-'}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {adminCorporateInfo?.mobile_number!==""?adminCorporateInfo.country_code2+" "+formatMobileNumber(adminCorporateInfo?.mobile_number):"-"}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1 mb-[30px]">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {adminCorporateInfo.country_code1} {formatMobileNumber(adminCorporateInfo.main_number)}</p>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-1">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {date}</p>
                                                </div>
                                            </div>
                                            {adminCorporateInfo.user_type==="corporate-user" && 
                                            <div className="w-3/4 px-1">
                                                <div className="w-full">
                                                    <p className="text-sm font-normal text-[#000]">Address</p>
                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                        {adminCorporateInfo.address!==""?adminCorporateInfo.address:'-'}</p>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    {/* otp list */}
                                    {(userType === 'super-admin') || 
 (userType === 'admin-user' && adminCorporateInfo?.user_type === 'corporate-user') ? (
     <OtpPreferenceList username={adminCorporateInfo?.user_name} />
) : null}

                                    {adminCorporateInfo?.user_id && (
                                        <ImportHistoryTable userId={adminCorporateInfo.user_id} />
                                    )}

                                    {adminCorporateInfo.user_type==="corporate-user" &&adminCorporateInfo?.organizations_and_subdivisions?.length>0&&
                                    <OrganizationListTable 
                                        id={isOrganization===undefined?id:corp_id}
                                        user_id={adminCorporateInfo?.user_id}
                                                
                                    />

                                    }
                                </div>
                                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                                <HelpGuideModal
                                    setHelpGuideModel={setHelpGuideModel}
                                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
                            </div>
                        </motion.div>
                    </div>
                </>}
            </div>
        </>
    )
}

export default ViewAdminCorporateUser;